<template>
  <div class="image-upload">
    <!-- 图片列表 -->
    <div class="image-list">
      <div
        v-for="(image, index) in imageList"
        :key="index"
        class="image-item"
        @click="previewImage(image)"
      >
        <img :src="image" alt="用户上传图片" class="image-preview" />
        <div class="image-overlay">
          <div class="image-actions">
            <i class="el-icon-zoom-in preview-icon" @click.stop="previewImage(image)"></i>
            <i class="el-icon-delete delete-icon" @click.stop="deleteImage(index)"></i>
          </div>
        </div>
      </div>

      <!-- 上传按钮 -->
      <div
        v-if="imageList.length < maxCount"
        class="upload-button"
        @click="triggerUpload"
      >
        <i class="el-icon-plus"></i>
        <span class="upload-text">上传图片</span>
        <!-- <span class="upload-tip">{{ imageList.length }}/{{ maxCount }}</span> -->
      </div>
    </div>

    <!-- 隐藏的文件输入框 -->
    <input
      ref="fileInput"
      type="file"
      multiple
      accept="image/*"
      @change="handleFileChange"
      style="display: none"
    />

    <!-- 图片预览对话框 -->
<!--    <el-dialog-->
<!--      :close-on-press-escape="false"  :close-on-click-modal="false"-->
<!--      title="图片预览"-->
<!--      :modal="false"-->
<!--      :visible.sync="previewVisible"-->
<!--      width="60%"-->
<!--      center-->
<!--      :before-close="closePreview"-->
<!--    >-->
<!--      <div class="preview-container">-->
<!--        <img :src="previewImageUrl" alt="预览图片" class="preview-image" />-->
<!--      </div>-->
<!--    </el-dialog>-->


  </div>
</template>

<script>
import config from "../../config/config";
export default {
  name: 'ImageUpload',
  props: {
    // 最大上传数量
    maxCount: {
      type: Number,
      default: 9
    },
    // 最大文件大小（MB）
    maxSize: {
      type: Number,
      default: 5
    },
    // 允许的文件类型
    acceptTypes: {
      type: Array,
      default: () => ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
    },
    // 图片列表（用于回显）
    value: {
      type: Array,
      default: () => []
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 上传接口地址
    uploadUrl: {
      type: String,
      default: config.BASE_URL + "/upload/image"
    },
    // 上传时的额外参数
    uploadParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      imageList: [],
      previewVisible: false,
      previewImageUrl: '',
      previewImageName: '',
      previewImageSize: 0,
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if(newVal!=''&&newVal!=null&&newVal!=undefined){
          this.imageList = [...newVal]
        }
      },
      immediate: true
    }
  },
  methods: {
    // 触发文件选择
    triggerUpload() {
      if (this.disabled) return
      this.$refs.fileInput.click()
    },

    // 处理文件选择
    handleFileChange(event) {
      const files = Array.from(event.target.files)
      if (files.length === 0) return

      // 检查文件数量限制
      if (this.imageList.length + files.length > this.maxCount) {
        this.$message.warning(`最多只能上传 ${this.maxCount} 张图片`)
        return
      }

      // 验证文件
      const validFiles = files.filter(file => this.validateFile(file))
      if (validFiles.length === 0) return

      // 上传文件
      this.uploadFiles(validFiles)

      // 清空文件输入框
      event.target.value = ''
    },

    // 验证文件
    validateFile(file) {
      // 检查文件类型
      if (!this.acceptTypes.includes(file.type)) {
        this.$message.error(`不支持的文件类型：${file.name}`)
        return false
      }

      // 检查文件大小
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message.error(`文件大小不能超过 ${this.maxSize}MB：${file.name}`)
        return false
      }

      return true
    },

    // 上传文件
    async uploadFiles(files) {
      console.log(files, "files");

      const totalFiles = files.length
      let uploadedCount = 0

      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        try {
          const result = await this.uploadSingleFile(file)
          if (result.status === 200) {
            this.imageList.push(result.data.path)
            uploadedCount++
          } else {
            this.$message.error(`上传失败：${file.name}`)
          }
        } catch (error) {
          console.log(error, "error");
          this.$message.error(`上传出错：${file.name} - ${error.message}`)
        }
      }

      // 所有文件上传完成后，统一触发 change 事件
      if (uploadedCount > 0) {
        this.emitChange()
        this.$message.success(`成功上传 ${uploadedCount} 张图片`)
      }
    },

    // 上传单个文件
    uploadSingleFile(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('image', file)

        // 添加额外参数
        Object.keys(this.uploadParams).forEach(key => {
          formData.append(key, this.uploadParams[key])
        })

        // 使用项目中的 request 工具上传
        import('@/utils/request').then(({ request }) => {
          request({
            url: this.uploadUrl,
            method: 'post',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(response => {
            if (response.status === 200) {
              resolve(response)
            } else {
              reject(new Error(response.data.message || '上传失败'))
            }
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 删除图片
    deleteImage(index) {
      this.$confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.imageList.splice(index, 1)
        this.emitChange()
        this.$message.success('删除成功')
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 预览图片
    previewImage(image) {
      this.previewImageUrl = image
      window.open(image,'_blank')
    },

    // 关闭预览
    closePreview() {
      this.previewVisible = false
      this.previewImageUrl = ''
      this.previewImageName = ''
      this.previewImageSize = 0
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // 触发 change 事件
    emitChange() {
      console.log(this.imageList, "this.imageList");
      this.$emit('input', this.imageList)
      this.$emit('change', this.imageList)
    },

    // 获取图片列表
    getImageList() {
      return this.imageList
    },

    // 清空图片列表
    clearImages() {
      this.imageList = []
      this.emitChange()
    },

    // 添加图片（用于外部调用）
    addImage(image) {
      if (this.imageList.length >= this.maxCount) {
        this.$message.warning(`最多只能上传 ${this.maxCount} 张图片`)
        return false
      }
      this.imageList.push(image)
      this.emitChange()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.image-upload {
  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .image-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;

    &:hover {
      border-color: #409eff;

      .image-overlay {
        opacity: 1;
      }
    }

    .image-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;

      .image-actions {
        display: flex;
        gap: 12px;

        i {
          color: white;
          font-size: 20px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: scale(1.1);
          }

          &.delete-icon:hover {
            background: rgba(245, 108, 108, 0.8);
          }
        }
      }
    }
  }

  .upload-button {
    width: 120px;
    height: 120px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fafafa;

    &:hover {
      border-color: #409eff;
      background: #f0f9ff;
    }

    i {
      font-size: 24px;
      color: #999;
      margin-bottom: 8px;
    }

    .upload-text {
      font-size: 14px;
      color: #666;
      margin-bottom: 4px;
    }

    .upload-tip {
      font-size: 12px;
      color: #999;
    }
  }

  .preview-container {
    text-align: center;
    margin-bottom: 20px;

    .preview-image {
      max-width: 100%;
      max-height: 400px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .preview-info {
    p {
      margin: 8px 0;
      color: #666;
    }
  }

  .upload-progress {
    text-align: center;

    .progress-text {
      margin-top: 12px;
      color: #666;
      font-size: 14px;
    }
  }
}

// 禁用状态
.image-upload.disabled {
  .upload-button {
    cursor: not-allowed;
    opacity: 0.6;

    &:hover {
      border-color: #d9d9d9;
      background: #fafafa;
    }
  }

  .image-item {
    cursor: default;

    &:hover {
      border-color: transparent;
    }
  }
}
</style>
